import React from "react";
import { FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";

const REASON_LABELS = {
  'eyes-off-target': 'Eyes off screen',
  'head-off-screen': 'Head off screen',
  'multiple-faces': 'Multiple faces detected',
  'tab-hidden': 'Tab hidden',
  'tab-switched': 'Tab switched',
  'no-face': 'No face detected',
};

function resolveReasonLabel(reason) {
  if (!reason) return 'Unknown activity';
  return REASON_LABELS[reason] || reason.replace(/-/g, ' ');
}

function getToastStyles(type) {
  if (type === 'violation' || type === 'violation-immediate') {
    return {
      background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
      icon: <FaTimesCircle style={{ fontSize: 20 }} />,
      accent: '#fee2e2',
    };
  }

  return {
    background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
    icon: <FaExclamationTriangle style={{ fontSize: 20 }} />,
    accent: '#fef3c7',
  };
}

function WarningToast({ toasts = [] }) {
  if (!Array.isArray(toasts) || toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      {toasts.map(({ id, type, reason, count, threshold }) => {
        const { background, icon, accent } = getToastStyles(type);
        const isViolation = type === 'violation' || type === 'violation-immediate';

        const title = isViolation
          ? `Violation ${count}${threshold ? ` / ${threshold}` : ''}`
          : `Warning ${count}${threshold ? ` / ${threshold}` : ''}`;

        const description = isViolation
          ? `Violation triggered: ${resolveReasonLabel(reason)}`
          : `${resolveReasonLabel(reason)}.${threshold ? ` ${threshold} warnings = 1 violation.` : ''}`;

        return (
          <div
            key={id}
            style={{
              background,
              color: '#fff',
              padding: '12px 20px',
              borderRadius: 12,
              boxShadow: '0 12px 28px rgba(15, 23, 42, 0.22)',
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              minWidth: 290,
              animation: 'slideInRight 0.25s ease-out',
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: accent,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#111827',
              }}
            >
              {icon}
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.2, marginBottom: 4 }}>
                {title}
              </div>
              <div style={{ fontSize: 12.5, opacity: 0.9, lineHeight: 1.4 }}>
                {description}
              </div>
            </div>
          </div>
        );
      })}

      <style>{`
        @keyframes slideInRight {
          from {
            transform: translateX(24px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default WarningToast;